import { EnvConfig } from "..";

const config: EnvConfig = {
  basketBFFBaseUrl: "http://localhost:3010/proxy/basket-ui",
  socialProofApi:
    "http://localhost:3010/proxy/product-badging/api/v1/social-proof-messaging",
  onlineStockBaseUrl:
    "https://api.integration.project4.com/online-stock/v2/available-stock",
  onlineStockApiKey: "AIzaSyA1LzkNrQFvBj0CAwl6X1vfCqP8lrJuMIY",
};

export default config;
